import React from 'react';
import { aboutData } from '../../../data/aboutData';
import Reveal from '../../helper/reveal';
import './about.css';

function About() {
    return (
        <section className='section about' id='about' aria-labelledby='about-title'>
            <div className='container'>
                <Reveal className='section-head'>
                    <span className='eyebrow'>01 / About</span>
                    <h2 id='about-title' className='section-title'>{aboutData.title}</h2>
                </Reveal>

                <div className='about__body'>
                    <Reveal className='about__text'>
                        {aboutData.paragraphs.map((text) => (
                            <p key={text}>{text}</p>
                        ))}
                    </Reveal>

                    <ul className='about__focus'>
                        {aboutData.focus.map((item, index) => (
                            <Reveal as='li' key={item.title} delay={index * 90} className='about__card'>
                                <h3>{item.title}</h3>
                                <p>{item.text}</p>
                                <ul className='about__tags' aria-label={`${item.title} technologies`}>
                                    {item.tags.map((tag) => (
                                        <li key={tag} className='chip'>{tag}</li>
                                    ))}
                                </ul>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default About;
